<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">Profile {{schoolname}} </h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="border mt-3 verify" *ngIf="data!= undefined">
                            <div class="row">
                                <div class="col-lg-12">
                                    <h4 class="mb-0 v_title"> &nbsp; Basic Information</h4>
                                </div>
                            </div>
                            <div class="row p-3 per_info">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>University:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Board"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Medium:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Medium"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Faculty:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Section"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College code:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["UDiseNo"]}}</p>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td width="50%">
                                                        <p><strong>Office:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Office"]}}</p>
                                                    </td>
                                                </tr> -->
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Type of trust:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["TypeOfTrust"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="data['AffiliationNumber'] != ''">
                                                    <td width="50%">
                                                        <p><strong>Affiliation no:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["AffiliationNumber"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="data['AffiliationNumberAcquireDate'] != ''">
                                                    <td width="50%">
                                                        <p><strong>Affiliation no acquire date:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["AffiliationNumberAcquireDate"]}}</p>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td width="50%">
                                                        <p><strong>Index number acquire date:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["AcquiredDate"]}}</p>
                                                    </td>
                                                </tr> -->
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Area:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Area"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>State:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["State"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>City:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["City"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Registration date:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["RegistrationDate"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Trust name:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Trust"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Trust address.:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["TrustAddress"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Trust contact/mobile no.:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["TrustMobileNo"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Trust mail id:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["TrustMailID"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College name:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolName"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College address:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolAddress"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College pincode:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Pincode"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College contact / mobile no.:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolMobileno"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College mail id:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolMailID"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College location:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolLocation"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College type:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["SchoolType"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Year</b></label>
                                    <select class="form-control" #YearID="ngModel" ngModel name="YearID"
                                        [(ngModel)]="yearid" (change)="getSchoolProfile(yearid)">
                                        <option *ngFor="let year of yearlist" [value]="year.value"
                                            [selected]="yearid == year.value">
                                            {{ year.text }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="TrusteeDetail != undefined && TrusteeDetail != null && TrusteeDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Trustee's Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Trustee's name</th>
                                                        <th>Trustee's address</th>
                                                        <th>Trustee's contact / mobile no.</th>
                                                        <th>Trustee's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of TrusteeDetail;">
                                                    <td>{{t.TrusteeName}}</td>
                                                    <td>{{t.TrusteeAddress}}</td>
                                                    <td>{{t.TrusteeMobileNo}}</td>
                                                    <td>{{t.TrusteeMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="PrincipalDetail != undefined && PrincipalDetail != null && PrincipalDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Principal/Supervisor/Director's Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Designation</th>
                                                        <th>Name</th>
                                                        <th>Mobile no.</th>
                                                        <th>Mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of PrincipalDetail;let j = index">
                                                    <td>{{t.Designation}}</td>
                                                    <td>{{t.PrincipalName}}</td>
                                                    <td>{{t.PrincipalMobileNo}}</td>
                                                    <td>{{t.PrincipalMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="InfraStructureDetail != undefined && InfraStructureDetail != null && InfraStructureDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Infrastructure Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Infrastructure name</th>
                                                        <th>No. of infrastructure</th>
                                                        <th>Infrastructure size</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of InfraStructureDetail;let j = index">
                                                    <td>{{t.InfrastructureName}}</td>
                                                    <td>{{t.NoOfInfrastructures}}</td>
                                                    <td>{{t.InfrastructureSize}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="EmployeeTypeDetail != undefined && EmployeeTypeDetail != null && EmployeeTypeDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Employee Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Employee category</th>
                                                        <th>No. of permanent employee</th>
                                                        <th>No. of Ad-Hoc employee</th>
                                                        <th>Total permanent salary</th>
                                                        <th>Total Ad-Hoc salary</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of EmployeeTypeDetail;let j = index">
                                                    <td>{{t.EmployeeType}}</td>
                                                    <td>{{t.NoOfPermanentEmployee}}</td>
                                                    <td>{{t.NoOfAdHocEmployee}}</td>
                                                    <td>{{t.TotalPermanentSalary}}</td>
                                                    <td>{{t.TotalAdhocSalary}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="EmployeeQualificationDetail != undefined && EmployeeQualificationDetail != null && EmployeeQualificationDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Employee Qualification Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Qualification type</th>
                                                        <th>No. of employees</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of EmployeeQualificationDetail;let j = index">
                                                    <td>{{t.Qualification}}</td>
                                                    <td>{{t.NoofEmployee}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Name of authorized person:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["AuthorizedPerson"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Designation:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["Designation"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Authorized person contact/mobile no.:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["MobileNo"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Authorized person whatsapp no.:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["WhatsAppNo"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                    *ngIf="StandardDetail != undefined && StandardDetail != null && StandardDetail.length > 0">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Course Details</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Course</th>
                                                        <th>Division details (Division Name - Student Counts)</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of StandardDetail;let j = index">
                                                    <td>{{t.Standard}}</td>
                                                    <td>{{t.DivisionDetail}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="border border-dark bg-custom m-3 p-2">
                                <h4>STUDENT'S COUNTS</h4>
                                <div class="row per_info ">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="table-responsive">
                                            <table class="table table-borderless mb-0">
                                                <tbody>
                                                    <tr *ngIf="data['playGroup'] > 0">
                                                        <td width="50%">
                                                            <p><strong>Play Group:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["playGroup"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['nursery'] > 0">
                                                        <td width="50%">
                                                            <p><strong>Nursery:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["nursery"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['jrKg'] > 0">
                                                        <td width="50%">
                                                            <p><strong>JrKg:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["jrKg"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['srKg'] > 0">
                                                        <td width="50%">
                                                            <p><strong>SrKg:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["srKg"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std1'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 1:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std1"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std2'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 2:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std2"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std3'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 3:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std3"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std4'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 4:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std4"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std5'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 5:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std5"]}}</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="table-responsive">
                                            <table class="table table-borderless mb-0">
                                                <tbody>
                                                    <tr *ngIf="data['std6'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 6:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std6"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std7'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 7:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std7"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std8'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 8:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std8"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std9'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 9:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std9"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std10'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD10:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std10"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std11sci'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 11 Sci:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std11sci"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std12sci'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 12 Sci:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std12sci"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std11com'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 11 Com:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std11com"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std12com'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 12 com:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std12com"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std11arts'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 11 Arts:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std11arts"]}}</p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="data['std12arts'] > 0">
                                                        <td width="50%">
                                                            <p><strong>STD 12 Arts:</strong></p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>{{data["std12arts"]}}</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="row p-3 per_info"
                                *ngIf="OwnerDetail != undefined && OwnerDetail != null && OwnerDetail.length > 0">
                                <div class="form-group col-lg-12 col-md-12 col-12">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Land Owner's Details</h4>
                                        <div class="table-responsive">
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Owner's name</th>
                                                            <th>Owner's mobile no</th>
                                                            <th>Owner's mail id</th>
                                                        </tr>
                                                    </thead>
                                                    <tr *ngFor="let o of OwnerDetail;let j = index">
                                                        <td>{{o.OwnerName}}</td>
                                                        <td>{{o.OwnerMobileNo}}</td>
                                                        <td>{{o.OwnerMailID}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row p-3 per_info"
                                *ngIf="ClassRoomDetail != undefined && ClassRoomDetail != null && ClassRoomDetail.length > 0">
                                <div class="form-group col-lg-12 col-md-12 col-12">
                                    <div class="border border-dark bg-custom p-2">
                                        <h4>Classroom Details (Classroom Name - Classroom Size) Total Classroom : {{data["NoOfClassroom"]}} </h4>
                                        <div class="table-responsive">
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <tr *ngFor="let cr of ClassRoomDetail;let j = index">
                                                        <td>{{cr.ClassroomName}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="row p-3 per_info">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Land area in square feet:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["LandArea"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Land construction group and total both:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["LandConstruction"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Pending salary increment amount:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["PendingSalaryIncrementAmount"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="table-responsive">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Pending salary increment description:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["PendingSalaryIncrementDescription"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Depreciation amount:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["DepreciationAmount"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Depreciation description:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{data["DepreciationDescription"]}}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div> -->
                            <div class="row p-3" *ngIf="documentList !=undefined && documentList.length > 0">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingOne">
                                                <h4 class="panel-title">
                                                    <a data-toggle="collapse" data-parent="#accordion"
                                                        href="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        College/Class Permission Letter
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel"
                                                aria-labelledby="headingOne">
                                                <div class="table-responsive">
                                                    <table id="example" class="table table-striped table-bordered"
                                                        style="width:100%">
                                                        <thead>
                                                            <tr>
                                                                <th class="pointer" scope="col">Sr. no.</th>
                                                                <th class="pointer" scope="col">Course</th>
                                                                <th class="pointer" scope="col">Preview</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let r of documentList ;let i = index">
                                                                <td>{{i+1}}</td>
                                                                <td>
                                                                    <p>{{r.Standard}}</p>
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        <a href="{{r.ViewURL}}" target="_blank">
                                                                            <img src="{{r.downloadURL}}"
                                                                                class="img-fluid no-img "
                                                                                style="width: 90px;height: 90px;"
                                                                                id="preview_{{i}}" />
                                                                        </a>
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>